import React, { useState } from "react";
import { Upload, Button, message, Progress } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { SCORM_GENERATE_PRESIGNED_URL } from "../apis/apis";

const ScormUploader = ({ set_fileKey }) => {
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [video_uploading_message,set_video_uploading_message] = useState("")
    

    const handleUpload = async ({ file, onSuccess, onError }) => {
        try {
            setUploading(true);
            setProgress(0);
            const FORM_DATA = new FormData();
            FORM_DATA.append("scrom_file", file.name);
            const response = await SCORM_GENERATE_PRESIGNED_URL(FORM_DATA);
            if (response?.data?.status) {
                await axios.put(response?.data?.uploadUrl, file, {
                    headers: {
                        "Content-Type": "application/zip",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        if (percent >= 100) {
                            set_video_uploading_message("Uploading and Verifying...");
                        }

                        setProgress(percent >= 100 ? 99 : percent);

                    },
                });
                set_fileKey(response?.data?.fileKey);
                setProgress(100);
            }
        }
        catch (err) {
            console.error(err);
            message.error("Upload failed!");
            onError(err);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <Upload
                accept=".zip"
                maxCount={1}
                customRequest={handleUpload}
                showUploadList={{ showRemoveIcon: false }}
            >
                <Button icon={<UploadOutlined />} loading={uploading}>
                    Upload SCORM Package
                </Button>
            </Upload>

            {uploading && <Progress percent={progress} size="small" />}
            {progress === 99 && <>  <p style={{color:"orange", position:"relative", top:"-17px"}}>{video_uploading_message}</p></>}
            {progress === 100 && <>  <p style={{color:"rgb(101, 231, 196)", position:"relative", top:"-17px"}}>Upload successful & verified</p></>}
        </div>
    );
};

export default ScormUploader;
